import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import RegisterSection from "../../components/register/register"
import SearchModel from "../../components/search_model/search"

const Register = () => {
    return (
        <>
            <Header />
            <RegisterSection/>
            <Footer />
            <SearchModel/>
        </>
    )
}

export default Register